import React, { useEffect, useState } from 'react';
import GeniustextInput from '../utility/component/mastertext';

import { Button } from '@mui/material';
import GeniusDatagrid from '../utility/component/datagrid/geniusDatagrid';
import { ModuleMasterColumns } from './columns';
import { useDispatch, useSelector } from 'react-redux';
import { selectWidth } from '../utility/Redux/profile';
import {
  DeleteModuleMasetr,
  ModuleMasetrHelp,
  SaveModuleMaster,
} from './function';
import { selectToken } from '../utility/Redux/security';
import {
  setAlertWithTitle,
  setModCompanyHelpStatus,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import AlertModalTwoButton from '../utility/component/modals/alertWithTwoButton';
import ModalHeaderStyle from '../utility/component/styles/modalHeader';
import { useNavigate } from 'react-router-dom';
import ModCompanyHelp from '../utility/component/modals/modCompanyHelp';
import { Close } from '@mui/icons-material';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import WhatsappTemplatehelp from '../help/whatsappSenderhelp';

const SenderMaster = () => {
  const [data, setData] = useState({
    product_name: '',
    messanger_id: '',
    from_whatsapp_no: '',
  });
  const [helpStatus, sethelpStatus] = useState(false);
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: '',
    msg: '',
    status: false,
    setStatus: '',
    button1: '',
    button1Click: '',
    button2: '',
    button2Click: '',
  });
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  return (
    <div className="w-full h-full flex justify-center bg-[#f5f5f7] p-4 ">
      <div className="text-sm  rounded-sm  h-full">
        <div className="bg-white rounded-t-sm  ">
          <ModalHeaderStyle
            header={'Whastapp Sender Master'}
            onClose={() => {
              navigate('/settings');
            }}
          />
        </div>
        <div
          style={{
            height: `calc(100% - 55px)`,
          }}
          className="  flex flex-col  "
        >
          <div className="flex bg-white p-3">
            <div>
              <GeniustextInput
                title={'Product Name'}
                type={'text'}
                width={'500px'}
                titleBold={600}
                search={() => {
                  sethelpStatus(true);
                }}
                value={data.product_name}
                onChange={(p) => {
                  setData((d) => {
                    return {
                      ...d,
                      product_name: p.target.value,
                    };
                  });
                }}
              />
              <GeniustextInput
                title={'Messanger ID'}
                type={'text'}
                width={'500px'}
                titleBold={600}
                value={data.messanger_id}
                onChange={(p) => {
                  setData((d) => {
                    return {
                      ...d,
                      messanger_id: p.target.value,
                    };
                  });
                }}
              />
              <GeniustextInput
                title={'Whatsapp Number'}
                type={'text'}
                width={'500px'}
                titleBold={600}
                value={data.from_whatsapp_no}
                onChange={(p) => {
                  setData((d) => {
                    return {
                      ...d,
                      from_whatsapp_no: p.target.value,
                    };
                  });
                }}
              />
            </div>
            <div className="flex flex-col ml-3 mt-[29px]">
              <div>
                <Button
                  // ref={updateRef}
                  onClick={() => {
                    if (
                      data.from_whatsapp_no &&
                      data.messanger_id &&
                      data.product_name
                    ) {
                      dispatch(setSpinnerLoading('Laoding'));
                      CallAPIPromise(
                        '/api/whatsAppSender/saveWhatsappSender',
                        data
                      )
                        .then(() => {
                          dispatch(
                            setAlertWithTitle({
                              title: 'Alert',
                              msg: 'Data saved',
                            })
                          );
                          setData({
                            product_name: '',
                            messanger_id: '',
                            from_whatsapp_no: '',
                          });
                        })
                        .finally(() => {
                          dispatch(setSpinnerLoading(false));
                        });
                    } else {
                      dispatch(
                        setAlertWithTitle({
                          title: 'Alert',
                          msg: 'Please fil all details',
                        })
                      );
                    }
                  }}
                  variant="contained"
                  style={{
                    textTransform: 'none',
                    letterSpacing: '1px',
                    backgroundColor: '#a8cf45',
                    width: 110,
                  }}
                >
                  <div className="text-black px-4 font-sans">Save </div>
                </Button>
              </div>
              <div className="mt-2">
                <Button
                  // ref={updateRef}
                  variant="contained"
                  style={{
                    textTransform: 'none',
                    letterSpacing: '1px',
                    backgroundColor: '#383535',
                    width: 110,
                  }}
                >
                  <div className="text-white font-sans px-4  ">Undo </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <WhatsappTemplatehelp
          status={helpStatus}
          onRowClick={(p) => {
            sethelpStatus(false);
            setData({
              ...p.row,
            });
          }}
          onClose={() => {
            sethelpStatus(false);
          }}
        />
        <AlertModalTwoButton
          details={alertTwoButtonModal}
          setAlertTwoButtonModal={setAlertTwoButtonModal}
        />
      </div>
    </div>
  );
};

export default SenderMaster;
